import type { WorkflowResult } from '@mastra/core/workflows';
import { z } from 'zod';

import { useRunWorkflow } from '../../../hooks/useRunWorkflow';

const WEATHER_WORKFLOW_ID = 'WeatherWorkflow';

const WeatherWorkflowInputSchema = z.object({
    city: z.string(),
});
const WeatherWorkflowOutputSchema = z.object({
    activities: z.string(),
});

export type WeatherWorkflowOutput = typeof WeatherWorkflowOutputSchema;

interface WeatherWorkflowInputData extends Record<string, unknown> {
    city: string;
}

export type WeatherWorkflowInput = typeof WeatherWorkflowInputSchema;

/** Exported so schema values count as used (runtime + type consumers). */
export { WeatherWorkflowInputSchema, WeatherWorkflowOutputSchema };

export type WeatherWorkflowResult = WorkflowResult<
    WeatherWorkflowInput,
    WeatherWorkflowInput,
    WeatherWorkflowOutput,
    []
> | null;

interface RunWeatherWorkflowArgs {
    inputData: WeatherWorkflowInputData;
}

export const useRunWeatherWorkflow = () => {
    const { mutateAsync, ...rest } = useRunWorkflow<WeatherWorkflowOutput>();

    const runWorkflow = async ({ inputData }: RunWeatherWorkflowArgs) => {
        return await mutateAsync({
            workflowId: WEATHER_WORKFLOW_ID,
            inputData,
        });
    };
    return { runWorkflow, ...rest };
};
